export default __webpack_public_path__ + "static/ogp-default-a8f3b46faa895d1679fffca8a2ac244a.png";